module.exports = __webpack_public_path__ + "img/sport_tennis.43cecee0.png";